import axios from 'axios'
import _ from 'lodash'
const state = {}

const mutations = {}

const getters = {
  data(state) {
    return state.data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
